module.exports = __webpack_public_path__ + "static/media/Relative-Faux-Web.65908b08.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Faux-Web.ttf
// module id = 734
// module chunks = 0